<mat-card-content *ngIf="data">
  <form #loginForm="ngForm" enctype="multipart/form-data">
    <mat-toolbar style="float:left;clear:both;width:100%;" color="secondary">
      <div style="width:30%;" *ngIf="proposta">
        {{ 'projectsList.titols.propostes' | translate }}
      </div>
      <div style="width:30%;" *ngIf="!proposta">
        {{ 'projectsList.titols.manifestacions' | translate }}
      </div>
      <div style="width:70%;float:right">
      <button *ngIf="proposta" matTooltip="{{ 'propostaMi.toolbar.anarTreball' | translate }}" attr.aria-label="{{ 'propostaMi.toolbar.anarTreball' | translate }}" matTooltipClass="tooltip-style" type="button" style="color:#000088;float: right; margin-left:10px ;margin-right: 0" mat-icon-button (click)="this.goProject()">
        <mat-icon color="primary" style="font-size:24px">assignment</mat-icon>
      </button>
      <button *ngIf="proposta" matTooltip="{{ 'propostaMi.toolbar.tornarPropostes' | translate }}" attr.aria-label="{{ 'propostaMi.toolbar.tornarPropostes' | translate }}" matTooltipClass="tooltip-style" type="button" style="color:#000088;float: right; margin-left:10px ;margin-right: 0" mat-icon-button (click)="this.goBack()">
        <mat-icon color="primary" style="font-size:24px">view_headline</mat-icon>
      </button>
      <button *ngIf="!proposta" matTooltip="{{ 'propostaMi.toolbar.tornarManifestacions' | translate }}" attr.aria-label="{{ 'propostaMi.toolbar.tornarManifestacions' | translate }}" matTooltipClass="tooltip-style" type="button" style="color:#000088;float: right; margin-left:10px ;margin-right: 0" mat-icon-button (click)="this.goBack()">
        <mat-icon color="primary" style="font-size:24px">view_headline</mat-icon>
      </button>
      <button *ngIf="rol == 2 || rol == 4" matTooltip="{{ 'propostaMi.toolbar.desarToolTip' | translate }}" attr.aria-label="{{ 'propostaMi.toolbar.desarToolTip' | translate }}" matTooltipClass="tooltip-style" style="color:#000088;float: right; margin-right: 0" mat-icon-button (click)="onSubmit()">
        <mat-icon color="primary" style="font-size:24px">save</mat-icon>
      </button>
      <button *ngIf="(rol == 2 || rol == 4) && proposta" matTooltip="{{ 'propostaMi.toolbar.esborrarPropostaToolTip' | translate }}" attr.aria-label="{{ 'propostaMi.toolbar.esborrarPropostaAriaLabel' | translate }}" matTooltipClass="tooltip-style" style="color:#000088;float: right; margin-right: 0" mat-icon-button (click)="esborrar('proposta')">
        <mat-icon color="accent" style="font-size:24px">delete</mat-icon>
      </button>
      <button *ngIf="(rol == 2 || rol == 4) && !proposta" matTooltip="{{ 'propostaMi.toolbar.esborrarMiToolTip' | translate }}" attr.aria-label="{{ 'propostaMi.toolbar.esborrarMiToolTip' | translate }}" matTooltipClass="tooltip-style" style="color:#000088;float: right; margin-right: 0" mat-icon-button (click)="esborrar('propostape')">
        <mat-icon color="accent" style="font-size:24px">delete</mat-icon>
      </button>
     </div>
    </mat-toolbar>
    <mat-progress-bar mode="indeterminate" color="warm" *ngIf="showAsyncProgress"></mat-progress-bar>
    <mat-card-content style="float:left;clear:both;padding: 24px 0px;margin-bottom: 0px;padding-bottom:0px">
      <h2 mat-line></h2>
      <div style="float:left;clear:none;width:20%;display: none;">
         <mat-form-field style="width:100%">
          <input matInput placeholder="{{ 'propostaMi.camps.codi' | translate }}" name="codi" maxlength="45" [(ngModel)]="data.codi" ngDefaultControl/>
         </mat-form-field>
      </div>
      <div style="float:left;clear:none;padding-top:10px;width:80%">
         <mat-form-field style="width:100%">
          <input matInput placeholder="{{ 'propostaMi.camps.nom' | translate }}" name="clau" maxlength="30" [(ngModel)]="data.clau" ngDefaultControl/>
         </mat-form-field>
      </div>
      <div style="float:left;clear:none;padding-top:10px;width:100%">
        <mat-form-field *ngIf="!proposta">
          <mat-select style="width:100%" [(ngModel)]="data.tipus_proposta" [ngModelOptions]="{standalone: true}" placeholder="{{ 'propostaMi.camps.tipus' | translate }}">
           <!-- <mat-option *ngFor="let tipus of possibleTipus" [value]="tipus.value" [selected]="tipus.value == data.tipus_proposta">{{tipus.text}}</mat-option> -->
           <mat-option *ngFor="let opcio of possibleTipus" [value]="opcio.codi">
             {{ opcio.text }}
           </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="proposta" style="width:150px">
          <mat-select style="width:100%" [(ngModel)]="data.tipus_proposta" [ngModelOptions]="{standalone: true}" placeholder="{{ 'propostaMi.camps.tipus' | translate }}">
           <mat-option [value]="1" selected>{{ 'propostaMi.camps.propostaOpcio' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field style="width:520px">
           <mat-select placeholder="{{ 'propostaMi.camps.cpv' | translate }}" multiple="{{true}}" name="cpv" style="width:100%"
           [(ngModel)]="cpv" ngDefaultControl>
              <mat-option *ngFor="let tipus of possibleCPV" [value]="tipus.value">{{tipus.text}}</mat-option>
           </mat-select>
        </mat-form-field>
        <mat-form-field style="width: 100px">
           <input matInput placeholder="{{ 'propostaMi.camps.idOportunitat' | translate }}" name="id_oportunitat"
            [(ngModel)]="data.id_oportunitat" ngDefaultControl style='font-weight: bold'/>
        </mat-form-field>
        <span *ngIf="tipus_proposta_inicial != data.tipus_proposta && data.tipus_proposta == 1 && !proposta" style="float:left;clear:left;color:red;font-size:0.8em" [innerHTML]="'propostaMi.avisos.creacioProposta' | translate"></span>
        <span *ngIf="tipus_proposta_inicial != data.tipus_proposta && data.tipus_proposta !== 1 && proposta" style="float:left;clear:left;color:red;font-size:0.8em">{{ 'propostaMi.avisos.conversioMi' | translate }}</span>
      </div>
      <mat-form-field style="width: 80%">
       <input matInput placeholder="{{ 'propostaMi.camps.titolOficial' | translate }}" name="titol"
        [(ngModel)]="data.titol" ngDefaultControl style='font-weight: bold'/>
      </mat-form-field>
      <mat-form-field style="width: 80%">
       <input matInput placeholder="{{ 'propostaMi.camps.titolMcrit' | translate }}" name="titol_oficial"
        [(ngModel)]="data.titol_oficial" ngDefaultControl style='font-weight: bold'/>
      </mat-form-field>
      <mat-form-field style="margin-top:5px;width: 22%">
        <input matInput placeholder="{{ 'propostaMi.camps.pais' | translate }}" name="pais" [(ngModel)]="data.pais" ngDefaultControl/>
      </mat-form-field>
      <mat-form-field style="margin-top:5px;width: 22%">
        <input matInput placeholder="{{ 'propostaMi.camps.regio' | translate }}" name="regio" [(ngModel)]="data.regio" ngDefaultControl/>
      </mat-form-field>
      <mat-form-field style="margin-top:5px;width: 22%">
        <input matInput placeholder="{{ 'propostaMi.camps.ciutat' | translate }}" name="ciutat" [(ngModel)]="data.ciutat" ngDefaultControl/>
      </mat-form-field>
      <div style="float:left;clear:both;margin-top:20px;width:100%">
        <mat-form-field>
          <mat-select [(ngModel)]="data.ambit_proposta" [ngModelOptions]="{standalone: true}" placeholder="{{ 'propostaMi.camps.ambit' | translate }}">
          <!-- <mat-option *ngFor="let ambit of possibleAmbits" [value]="ambit" [selected]="ambit === data.ambit_proposta">{{ambit}}</mat-option> -->
            <mat-option *ngFor="let opcio of possibleAmbits" [value]="opcio.codi">
              {{ opcio.text }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-select [(ngModel)]="data.empresa" [ngModelOptions]="{standalone: true}" placeholder="{{ 'propostaMi.camps.propostaDe' | translate }}" name="empresa">
          <mat-option value="" [attr.selected]="data.empresa === '' ? true : false"></mat-option>
          <mat-option value="Multicriteri MCRIT AIE" [attr.selected]="data.empresa === 'Multicriteri MCRIT AIE' ? true : false">Multicriteri MCRIT AIE</mat-option>
          <mat-option value="Ersília" [attr.selected]="data.empresa === 'Ersília' ? true : false">Ersília</mat-option>
          <mat-option value="Geovincles" [attr.selected]="data.empresa === 'Geovincles' ? true : false">Geovincles</mat-option>
          <mat-option value="MCRIT" [attr.selected]="data.empresa === 'MCRIT' ? true : false">MCRIT</mat-option>
          <mat-option value="Multicriteri" [attr.selected]="data.empresa === 'Multicriteri' ? true : false">Multicriteri</mat-option>
          <mat-option value="Consorci" [attr.selected]="data.empresa === 'Consorci' ? true : false">{{ 'propostaMi.camps.consorci' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field [style.display]="data.empresa == 'Consorci'?'none':'inline-block'">
          <mat-select style="margin-top:5px" [(ngModel)]="data.tipus_participacio" [ngModelOptions]="{standalone: true}" placeholder="{{ 'propostaMi.camps.tipusParticipacio' | translate }}" name="tipus_participacio">
          <mat-option value="Lider" [attr.selected]="data.tipus_participacio === 'Lider' ? true : false">{{ 'propostaMi.camps.lider' | translate }}</mat-option>
          <mat-option value="Soci" [attr.selected]="data.tipus_participacio === 'Soci' ? true : false">{{ 'propostaMi.camps.soci' | translate }}</mat-option>
          <mat-option value="Col·laborador" [attr.selected]="data.tipus_participacio === 'Col·laborador' ? true : false">{{ 'propostaMi.camps.collaborador' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field [style.display]="data.empresa == 'Consorci'?'inline-block':'none'" style="width:450px">
          <input matInput placeholder="{{ 'propostaMi.camps.nomConsorci' | translate }}" name="nom_consorci" [(ngModel)]="data.nom_consorci" ngDefaultControl  [matAutocomplete]="auto" style="margin-top:5px"/>
          <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let codi of possibleUtes" [value]="codi.nom">{{codi.codi}} - {{codi.nom}}</mat-option>
        </mat-autocomplete>
        </mat-form-field>
        <mat-form-field [style.display]="data.empresa == 'Consorci'?'inline-block':'none'">
          <input matInput placeholder="{{ 'propostaMi.camps.cifConsorci' | translate }}" name="cif_consorci" [(ngModel)]="data.cif_consorci" ngDefaultControl style="margin-top:5px"/>
        </mat-form-field>
      </div>
      <div style="float:left;clear:both;margin-top:5px;width:100%">
        <mat-form-field style="width:130px;margin-top:5px">
         <input matInput type="date" style="width:130px" (ngModelChange)="chgDataPresentacio($event)"
          placeholder="{{ 'propostaMi.dates.dataLimitPresentacio' | translate }}" name="data_limit_presentacio"
          [ngModel]="data.data_limit_presentacio" ngDefaultControl/>
        </mat-form-field>
        <mat-form-field style="width:80px;margin-top:5px">
         <input matInput type="time" style="width:80px"
          placeholder="{{ 'propostaMi.dates.horaLimitPresentacio' | translate }}" name="hora_limit_presentacio"
          [(ngModel)]="data.hora_limit_presentacio" ngDefaultControl/>
        </mat-form-field>
        <mat-form-field style="width:130px;margin-top:5px">
         <input matInput type="date" style="width:130px"
          placeholder="{{ 'propostaMi.dates.dataLimitRequeriment' | translate }}" name="data_documentacio"
          [(ngModel)]="data.data_documentacio" ngDefaultControl/>
        </mat-form-field>
        <mat-form-field style="width:130px;margin-top:5px">
         <input matInput type="date" style="width:130px"
          placeholder="{{ 'propostaMi.dates.dataLimitAclariments' | translate }}" name="data_aclariments"
          [(ngModel)]="data.data_aclariments" ngDefaultControl/>
        </mat-form-field>
        <mat-form-field style="width:130px;margin-top: 10px">
         <input matInput type="date" style="width:130px"
          placeholder="{{ 'propostaMi.dates.dataAprovacio' | translate }}" name="data_aprovacio_prop"
          [(ngModel)]="data.data_aprovacio_prop" ngDefaultControl/>
        </mat-form-field>
        <mat-form-field style="width:130px;margin-top: 10px">
         <input matInput type="date" style="width:130px"
          placeholder="{{ 'propostaMi.dates.dataAdjudicacio' | translate }}" name="data_presentacio_prop"
          [(ngModel)]="data.data_presentacio_prop" ngDefaultControl/>
        </mat-form-field>
        <mat-form-field style="width:130px;margin-top: 10px">
         <input matInput type="date" style="width:130px"
          placeholder="{{ 'propostaMi.dates.dataFormalitzacio' | translate }}" name="data_negociacio_prop"
          [(ngModel)]="data.data_negociacio_prop" ngDefaultControl/>
        </mat-form-field>
      </div>
    <mat-card-content style="width:100%;float:left;clear:left;padding:5px">
      <div style="float:left;clear:both;width:100%;padding:5px">
       <mat-form-field style="float: left;clear: left;width:10%;display:none">
        <input matInput placeholder="{{ 'propostaMi.dates.data' | translate }}" name="dia" type="date" [(ngModel)]="dia" ngDefaultControl/>
       </mat-form-field>
       <button color="primary" mat-icon-button matTooltip="{{ 'propostaMi.seguiment.afegirDataToolTip' | translate }}" attr.aria-label="{{ 'propostaMi.seguiment.afegirDataToolTip' | translate }}" matTooltipClass="tooltip-style" (click)="afegir(null)" style="margin-top:15px;float: left;clear: none;width:2%">
         <mat-icon style="font-size:24px;font-weight:bold">note_add</mat-icon>
       </button>
       <mat-form-field style="width:40%;float:left;clear:none;margin-top:10px;margin-left: 20px;height:40px">
        <mat-select style="width:100%" placeholder="{{ 'propostaMi.seguiment.seguimentTreballs' | translate }}" (selectionChange)="afegir($event)">
          <mat-option *ngFor="let tipus of seguimentsTreballs" [value]="tipus.value">{{tipus.text}}</mat-option>
        </mat-select>
       </mat-form-field>
      </div>
      <div style="float:left;clear:both;margin-top:0px;width:95%;padding-left: 5px">
         <quill-editor #quillEditor [styles]="{height: '200px', backgroundColor: '#EEEEEE'}" [(ngModel)]="data.nota" name="nota" placeholder="{{ 'propostaMi.seguiment.seguimentTreballsPlaceholder' | translate }}" (onSelectionChanged)="setPos($event)"></quill-editor>
         <button color="primary" mat-icon-button matTooltip="{{ 'propostaMi.seguiment.afegirDataToolTip' | translate }}" attr.aria-label="{{ 'propostaMi.seguiment.afegirDataToolTip' | translate }}" matTooltipClass="tooltip-style" (click)="afegirE()" style="float: left;clear: none;width:2%">
         <mat-icon style="font-size:24px;font-weight:bold">note_add</mat-icon>
         </button>
         <textarea style="width:100%;height:'100px';backgroundColor:'#dee8f4'" [(ngModel)]="data.nota_e" name="nota_e" placeholder="{{ 'propostaMi.seguiment.supervisio' | translate }}" (onSelectionChanged)="setPos($event)"></textarea>
      </div>
    </mat-card-content>
      
      <div style="float:left;clear:both;margin-top:20px;width:100%">
        <h3 mat-line style="margin-top:10px">{{ 'propostaMi.tematiques.titol' | translate }}</h3>
        <div style="float:left;clear:left;width:100%">
          <mat-form-field style="width: 32%">
            <mat-select placeholder="{{ 'propostaMi.tematiques.serveisRequerit' | translate }}" multiple="{{true}}" name="tematica2" style="height:25px;margin-top:5px;width:100%"
          [(ngModel)]="tematica2" ngDefaultControl>
              <mat-option *ngFor="let ambit of possibleTematiques2" [value]="ambit.codi">{{ambit.text}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field style="width: 32%">
            <mat-select placeholder="{{ 'propostaMi.tematiques.sectorsRequerit' | translate }}" multiple="{{true}}" name="tematica3" style="height:25px;margin-top:5px;width:100%"
          [(ngModel)]="tematica3" ngDefaultControl>
              <mat-option *ngFor="let ambit of possibleTematiques3" [value]="ambit.codi">{{ambit.text}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div style="float:left;clear:left;width:100%;padding-top:25px">
          <mat-form-field style="width: 32%">
            <mat-select placeholder="{{ 'propostaMi.tematiques.tipusEspecific' | translate }}" multiple="{{true}}" name="tematica1" style="height:25px;margin-top:5px;width:100%"
          [(ngModel)]="tematica1" ngDefaultControl>
              <mat-option *ngFor="let ambit of possibleTematiques1" [value]="ambit.codi">{{ambit.text}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field style="width: 32%">
            <mat-select placeholder="{{ 'propostaMi.tematiques.sectorEspecific' | translate }}" multiple="{{true}}" name="tematica4" style="height:25px;margin-top:5px;width:100%"
          [(ngModel)]="tematica4" ngDefaultControl>
              <mat-option *ngFor="let ambit of possibleTematiques4" [value]="ambit.codi">{{ambit.text}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field style="width: 32%">
            <mat-select placeholder="{{ 'propostaMi.tematiques.sistemes' | translate }}" multiple="{{true}}" name="tematica5"  style="height:25px;margin-top:5px;width:100%"
          [(ngModel)]="tematica5" ngDefaultControl>
              <mat-option *ngFor="let ambit of possibleTematiques5" [value]="ambit.codi">{{ambit.text}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div style="float:left;clear:both;margin-top:20px;width:100%">
        <h3 mat-line style="">{{ 'propostaMi.estat.titol' | translate }}</h3>
        <div style="float:left;clear:none;padding-top:10px;width:200px">
          <mat-form-field style="width:100%">
            <mat-select style="float:left;width:100%;height: 30px" [(ngModel)]="data.estat_proposta" [ngModelOptions]="{standalone: true}" placeholder="{{ 'propostaMi.estat.placeholder' | translate }}" (ngModelChange)="onEstatChange()">
            <mat-option *ngFor="let state of possibleStates" [value]="state.codi" [selected]="state.codi === data.estat_proposta">{{state.text}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div style="float:left;clear:none;padding-top:10px;width:50px">
           <button matTooltip="{{ 'propostaMi.estat.avaluacioToolTip' | translate }}" attr.aria-label="{{ 'propostaMi.estat.avaluarAriaLabel' | translate }}" matTooltipClass="tooltip-style" type="button" style="color:#000088;float: right; margin-left:10px;margin-right: 0" mat-icon-button (click)="avaluar(data.codi)">
          <mat-icon color="primary" style="font-size:24px">view_headline</mat-icon>
          </button>
        </div>
        <div *ngIf="proposta && data.estat_proposta == 'Abandonada'" style="float:left;clear:none;padding-top:10px;width:100px;margin-left:20px">
          <mat-form-field style="width:100%">
            <mat-select style="width:100%;height: 30px" [(ngModel)]="data.motiu_estat" [ngModelOptions]="{standalone: true}" placeholder="{{ 'propostaMi.estat.motius' | translate }}">
              <mat-option *ngFor="let motius of possibleMotius" [value]="motius.value" [selected]="motius.value == data.motiu_estat">{{motius.text}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div *ngIf="proposta && (data.estat_proposta == 'Presentada amb requeriments' || data.estat_proposta == 'Aprovada en contractació' || data.estat_proposta == 'Contractada')" style="float:left;clear:none;padding-top:10px;width:220px;margin-left:20px">
          <mat-form-field style="width:100%">
            <mat-select style="width:100%;height: 30px" [(ngModel)]="data.tipus_incidencia" [ngModelOptions]="{standalone: true}" placeholder="{{ data.estat_proposta == 'Contractada' ? ('propostaMi.camps.tipus' | translate) : ('propostaMi.estat.incidencies' | translate) }}">
             <mat-option *ngFor="let tipus of incidenciesActuals" [value]="tipus.text" [selected]="tipus.text === data.tipus_incidencia">{{tipus.text}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div *ngIf="!proposta && data.estat_proposta == 'Presentada amb requeriments'" style="float:left;clear:none;padding-top:10px;width:220px;margin-left:20px">
          <mat-form-field style="width:100%">
            <mat-select style="width:100%;height: 30px" [(ngModel)]="data.tipus_incidencia" [ngModelOptions]="{standalone: true}" placeholder="{{ 'propostaMi.estat.incidencies' | translate }}">
             <mat-option *ngFor="let tipus of possiblePrePropIncidencies" [value]="tipus.text" [selected]="tipus.text === data.tipus_incidencia">{{tipus.text}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div style="float:left;clear:left;margin-top:20px;width:50%" *ngIf="proposta">
        <h3 mat-line style="margin-top:10px">{{ 'propostaMi.durada.titol' | translate }}</h3>
        <mat-form-field style="width:130px">
         <input matInput type="date" style="width:130px"
          placeholder="{{ 'propostaMi.durada.dataIniciPossible' | translate }}" name="data_inici_possible"
          [(ngModel)]="data.data_inici_possible" ngDefaultControl/>
        </mat-form-field>
        <mat-form-field style="width:95px;margin-left:20px">
         <input matInput type="number" step="0.01"
          placeholder="{{ 'propostaMi.durada.duradaMesos' | translate }}" name="durada_mesos"
          [(ngModel)]="data.durada_mesos" ngDefaultControl style="width:95px"/>
        </mat-form-field>  
      </div>
      <div style="float:left;clear:both;margin-top:20px;width:100%">
        <h3 mat-line style="margin-top:10px">{{ 'propostaMi.economia.titol' | translate }}
        <button mat-icon-button style="clear:none;padding-left:10px;font-size:10px" color="primary"
            (click)="openCurrencyDialog()"
            matTooltip="{{ 'propostaMi.economia.canviMonedaToolTip' | translate }}"
            attr.aria-label="{{ 'propostaMi.economia.canviMonedaAriaLabel' | translate }}">
            <mat-icon>currency_exchange</mat-icon>
        </button>
        </h3>
        <div style="float:left;clear:none;width:100%">
        <mat-form-field style="width:170px">
         <input matInput type="number" step="0.01"
          placeholder="{{ 'propostaMi.economia.pressupostLicitacio' | translate }}" name="pressupost_licitacio"
          [(ngModel)]="data.pressupost_licitacio" ngDefaultControl style="width:170px"
         />
        </mat-form-field>
        <mat-form-field style="width:100px"> 
           <mat-select style="width:100px" [(ngModel)]="data.moneda_pressupost_licitacio" placeholder="{{ 'propostaMi.economia.moneda' | translate }}" name="moneda_pressupost_licitacio">
            <!-- <mat-option *ngFor="let moneda of possibleMonedes" [value]="moneda.value" [selected]="moneda.value === data.moneda_pressupost_licitacio">{{moneda.text}}</mat-option> -->
            <mat-option *ngFor="let opcio of possibleMonedes" [value]="opcio.codi">
              {{ opcio.text }}
            </mat-option>
           </mat-select>
        </mat-form-field>
        <mat-form-field style="width:100px">  
          <input matInput type="number" step="0.01" style="width:100px"
          placeholder="{{ 'propostaMi.economia.canvi' | translate }}" name="canvi_moneda_pressupost_licitacio"
          [(ngModel)]="data.canvi_moneda_pressupost_licitacio" formatNumberPipe ngDefaultControl
         />
        </mat-form-field>
        <mat-form-field style="width:170px">  
          <input matInput type="number" disabled style="width:170px;color:#777777"
          placeholder="{{ 'propostaMi.economia.pressupostLicitacioEur' | translate }}"
          value="{{data.canvi_moneda_pressupost_licitacio*data.pressupost_licitacio}}" formatNumberPipe
         />
        </mat-form-field> 
        </div>
        
        <div style="float:left;clear:none;width:100%" *ngIf="proposta">
        <mat-form-field style="width:170px">
         <input matInput type="number" step="0.01" (click)="percentPropi($event)"
          placeholder="{{ 'propostaMi.economia.pressupostOfertat' | translate }}" name="pressupost_ofertat"
          [(ngModel)]="data.pressupost_ofertat" ngDefaultControl style="width:170px"
         />
        </mat-form-field>
        <mat-form-field style="width:100px"> 
          <mat-select style="width:100px" [(ngModel)]="data.moneda_pressupost_ofertat" placeholder="{{ 'propostaMi.economia.moneda' | translate }}" name="moneda_pressupost_ofertat">
          <!-- <mat-option *ngFor="let moneda of possibleMonedes" [value]="moneda.value" [selected]="moneda.value === data.moneda_pressupost_ofertat">{{moneda.text}}</mat-option> -->
            <mat-option *ngFor="let opcio of possibleMonedes" [value]="opcio.codi">
              {{ opcio.text }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field style="width:100px">  
          <input matInput type="number" step="0.01" style="width:100px"
          placeholder="{{ 'propostaMi.economia.canvi' | translate }}" name="canvi_moneda_pressupost_ofertat"
          [(ngModel)]="data.canvi_moneda_pressupost_ofertat" formatNumberPipe ngDefaultControl
         />
        </mat-form-field>
        <mat-form-field style="width:170px">  
          <input matInput type="number" disabled style="width:170px;color:#777777"
          placeholder="{{ 'propostaMi.economia.pressupostOfertatEur' | translate }}"
          value="{{data.canvi_moneda_pressupost_ofertat*data.pressupost_ofertat}}" formatNumberPipe
         />
        </mat-form-field>
        <mat-form-field style="width:100px">  
          <input matInput type="number" disabled style="width:90px;color:#777777"
          placeholder="{{ 'propostaMi.economia.percentBaixa' | translate }}"
          value="{{(data.pressupost_licitacio - data.pressupost_ofertat)/data.pressupost_licitacio*100}}" formatNumberPipe
         />
        </mat-form-field>       
        </div>
        <div style="float:left;clear:none;width:100%" *ngIf="proposta">
        <mat-form-field style="width:170px">
         <input matInput type="number" step="0.01" (change)="formatUserNumber('impostos')"
          placeholder="{{ 'propostaMi.economia.impostosIva' | translate }}" name="impostos"
          [(ngModel)]="data.impostos" ngDefaultControl style="width:170px"
         />
        </mat-form-field>
        <mat-form-field style="width:170px">
          <input matInput type="number" step="0.01" style="width:170px"
          placeholder="{{ 'propostaMi.economia.impostosLocal' | translate }}" name="impostos_loc"
          [(ngModel)]="data.impostos_loc" formatNumberPipe ngDefaultControl
        />
        </mat-form-field>
        </div>
        <div style="float:left;clear:left; width:100%" *ngIf="proposta">
        <mat-form-field style="width:170px">
         <input matInput type="number" step="0.01" (click)="percentPropi($event)" 
          placeholder="{{ 'propostaMi.economia.pressupostPropiPrevist' | translate }}" name="import_propi"
          [(ngModel)]="data.import_propi" ngDefaultControl style="width:170px"
         />
        </mat-form-field>
        <mat-form-field style="width:100px"> 
           <mat-select style="width:100px" [(ngModel)]="data.moneda_import_propi" placeholder="{{ 'propostaMi.economia.moneda' | translate }}" name="moneda_import_propi">
            <!-- <mat-option *ngFor="let moneda of possibleMonedes" [value]="moneda.value" [selected]="moneda.value === data.moneda_import_propi">{{moneda.text}}</mat-option>-->
            <mat-option *ngFor="let opcio of possibleMonedes" [value]="opcio.codi">
              {{ opcio.text }}
            </mat-option>
           </mat-select>
        </mat-form-field>
        <mat-form-field style="width:100px">  
          <input matInput type="number" step="0.01" style="width:100px"
          placeholder="{{ 'propostaMi.economia.canvi' | translate }}" name="canvi_moneda_import_propi"
          [(ngModel)]="data.canvi_moneda_import_propi" formatNumberPipe ngDefaultControl
         />
        </mat-form-field>
        <mat-form-field style="width:170px">   
          <input matInput type="number" disabled style="width:170px;color:#777777"
          placeholder="{{ 'propostaMi.economia.pressupostPropiEur' | translate }}"
          value="{{data.canvi_moneda_import_propi*data.import_propi}}" formatNumberPipe
         />
        </mat-form-field> 
        <mat-form-field style="width:60px">
         <input matInput type="number" placeholder="{{ 'propostaMi.economia.percentPropi' | translate }}" name="percent_propi" type="noSpin"
          ngDefaultControl style="width:60px" disabled [ngModel]="percentatge_propi | number:'1.2-2'"
         />
        </mat-form-field> 
        </div>
      </div>
      <div style="float:left;clear:left; width:100%;margin-bottom:20px;height:50px">
        <mat-form-field style="float:left;clear:none;width:80%">
          <input matInput style="width:100%" placeholder="{{ 'propostaMi.url' | translate }}" name="url" [(ngModel)]="data.url" ngDefaultControl/>
        </mat-form-field>
        <div class="lbl_dlg" style="float:left;clear:none;margin-left:10px;padding-top:25px;width:30px" *ngIf="data.url">
          <a href="{{data.url}}" style="color:#3f51b5" target="_blank"><mat-icon>cloud_circle</mat-icon></a>
        </div>
      </div>
<!--
      <div style="float:left;clear:left; width:100%;margin-bottom:20px;height:30px">
        <div class="lbl_dlg" style="padding-top:7px;float:left;clear:left;width:200px">Documentació de la proposta:</div>
        <div class="lbl_dlg" style="float:left;clear:none;margin-left:10px;margin-top:5px" *ngIf="data.filename"><a href="#" (click)="desarFitxer($event,data.filename,'documents/proposals')" alt="Veure l'arxiu (si s'ha desat el formulari previament)">{{data.filename}}</a>
        </div>
        <div class="lbl_dlg" style="margin-left:10px;padding-top:7px" *ngIf="data.filename">
          <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;margin-top: -20px;cursor:pointer" (click)="data.filename=''" color="primary">delete_forever</mat-icon>
        </div>
      </div>

      <div style="float:left;clear:left;width:100%;padding-bottom:60px">
       <div style="float:left;clear:left;width:100%">
        <div style="float:left;clear:left;position: absolute;width:100%;height:30px;z-index:1;background-color: white">
          <div style="float:left;clear:none;padding-top:5px">Carregar un document</div>
          <div style="float:left;clear:none">
            <label for="file">
              <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;cursor:pointer" color="primary" matTooltip="L'extensió del fitxer ha de'estar en minúscules." aria-label="L'extensió del fitxer ha de'estar en minúscules." matTooltipClass="tooltip-style">cloud_upload</mat-icon></label>
          </div>
        </div>

        <div style="float:left;clear:left;position: absolute;width:100%">
          <input mat-raised-button color="primary" type="file" filter="jpg;png;doc;docx;pdf;xls;xlsx;gif;zip;rar;odt;ods;ppt;pptx" style="width:80%" placeholder="" id="file" name="file" (change)="onFileChange($event, 'file')"/> (100Mb màx.)
        </div>
       </div>
      </div>

      <div style="float:left;clear:left; width:100%;margin-bottom:20px;height:30px" *ngIf="proposta">
        <div class="lbl_dlg" style="padding-top:7px;float:left;clear:left;width:200px">Solvència tècnica:</div>
        <div class="lbl_dlg" style="float:left;clear:none;margin-left:10px;margin-top:5px" *ngIf="data.filesolvname"><a href="#" (click)="desarFitxer($event,data.filesolvname,'documents/solvencia')" alt="Veure l'arxiu (si s'ha desat el formulari previament)">{{data.filesolvname}}</a>
        </div>
        <div class="lbl_dlg" style="margin-left:10px;padding-top:7px" *ngIf="data.filesolvname">
          <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;margin-top: -20px;cursor:pointer" (click)="data.filesolvname=''" color="primary">delete_forever</mat-icon>
        </div>
      </div>
      <div style="float:left;clear:left;width:100%;padding-bottom:60px" *ngIf="proposta">
       <div style="float:left;clear:left;width:100%">
        <div style="float:left;clear:left;position: absolute;width:100%;height:30px;z-index:1;background-color: white">
          <div style="float:left;clear:none;padding-top:5px">Carregar la solvència tècnica</div>
          <div style="float:left;clear:none">
            <label for="filesolv">
              <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;cursor:pointer" color="primary" matTooltip="L'extensió del fitxer ha de'estar en minúscules." aria-label="L'extensió del fitxer ha de'estar en minúscules." matTooltipClass="tooltip-style">cloud_upload</mat-icon></label>
          </div>
        </div>
        <div style="float:left;clear:left;position: absolute;width:100%">
          <input mat-raised-button color="primary" type="file" filter="jpg;png;doc;docx;pdf;xls;xlsx;gif;zip;rar;odt;ods;ppt;pptx" style="width:80%" placeholder="" id="filesolv" name="filesolv" (change)="onFileChange($event, 'filesolv')"/> (100Mb màx.)
        </div>
       </div>
      </div>
-->
    </mat-card-content>
  </form>
</mat-card-content>
<!-- <datalist id="possibleStates">
  <mat-option *ngFor="let state of possibleStates" value="{{state}}">{{state}}</mat-option>
</datalist>
<datalist id="tipusParticipacio">
  <mat-option value="Lider">Lider</mat-option>
  <mat-option value="Soci">Soci</mat-option>
  <mat-option value="Col·laborador">Col·laborador</mat-option>
</datalist>
<datalist id="ambitProposta">
  <mat-option *ngFor="let ambit of possibleAmbits" value="{{ambit}}">{{ambit}}</mat-option>
</datalist>
-->
